export default ".marged-top{margin-top:30px}";